// extracted by extract-css-chunks-webpack-plugin
module.exports = {"inlineGiftAmountGroup":"gift-amount-select__inlineGiftAmountGroup__mlH7A"};